import { COLOR_PALETTE } from "common/colors";
import { DEFAULT_FONT_FAMILY } from "common/constants";
import styled from "styled-components";

export const Root = styled.div`
  font-family: ${DEFAULT_FONT_FAMILY};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Message = styled.span`
  font-size: 30px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${COLOR_PALETTE.LIGHT_GREY_2};
`;

export const EmptyMessageContainer = styled.div`
  position: relative;
`;